import React from 'react';
import { getIntl } from '../../../../../../../utils/intl';
import CopyOrganizationNoteToClients, {
    useCopyOrganizationNoteToClientsState,
} from '../../../../../../shared/ClientRecord/CopyOrganizationNoteToClients';
import { AnimateLoadedContent } from '../../../../../../v2BaseComponents/Loader';
import { SideDrawerButtonContainer } from '../../../../../../v2BaseComponents/Form/SideDrawerFormContainer';

const intl = getIntl('copy-organization-notes', {
    resourceNotes: 'Resource Notes',
    cancel: 'Cancel',
    share: 'Share',
});

export type CopyOrganizationNotesSideDrawerContentOwnProps = {
    destinationMedicalProfileIds: string[];
    onClose: (force: boolean) => void;
};

export type CopyOrganizationNotesSideDrawerContentProps = CopyOrganizationNotesSideDrawerContentOwnProps;

const CopyOrganizationNotesSideDrawerContent: React.FC<CopyOrganizationNotesSideDrawerContentProps> = (props) => {
    const { isInitializing, isSubmitting, selectedNoteIds, onNoteSelection, noteSelectOptions, onSubmit, canSubmit } =
        useCopyOrganizationNoteToClientsState({
            onClose: () => props.onClose(false),
            destinationMedicalProfileIds: props.destinationMedicalProfileIds,
        });

    const isLoading = isInitializing || isSubmitting;
    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (
                <SideDrawerButtonContainer
                    contentContainerStyle={{ padding: 0 }}
                    disableScroll
                    buttons={[
                        {
                            title: intl('cancel'),
                            variant: 'secondary',
                            onPress: () => props.onClose(true),
                            isDisabled: isLoading,
                            testID: 'form-submit-cancel',
                            icon: 'XCircle',
                        },
                        {
                            title: `${intl('share')}${selectedNoteIds.length ? ` (${selectedNoteIds.length})` : ''}`,
                            variant: 'primary',
                            onPress: onSubmit,
                            isDisabled: !canSubmit || isLoading,
                            testID: 'form-submit-button',
                            icon: 'Share2',
                        },
                    ]}
                >
                    <CopyOrganizationNoteToClients
                        noteSelectOptions={noteSelectOptions}
                        onNoteSelection={onNoteSelection}
                        selectedNoteIds={selectedNoteIds}
                        isDisabled={isSubmitting}
                        flatCards
                    />
                </SideDrawerButtonContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(CopyOrganizationNotesSideDrawerContent);
